export const getPageDynamicId = (pagePath = '', containingIdPages) => {
    let dynamicId = '';

    for (let i = 0; i < containingIdPages.length; i++) {
        const pageWithId = pagePath.match(new RegExp(`^${containingIdPages[i]}/(?<id>.+)`));

        if (pageWithId) {
            dynamicId = pageWithId.groups.id;

            break;
        }
    }

    return dynamicId;
};
